import { IOption } from "@app/common";

export interface OptionFormValues extends Partial<IOption> { }

export const transformToUpdatableFormOption = (option?: Partial<IOption>): OptionFormValues => {
  return {
    name: option?.name,
    disabled: option?.disabled,
    mandatory: option?.mandatory,
    freeQuantity: option?.freeQuantity,
    maxChoiceCount: option?.maxChoiceCount,
    products: option?.products,
    position: option?.position
  }
}
